import { RecentRouteStorage } from 'features/navigation/recentRoutes'
import { useGeckoPermissions } from 'features/permissions'
import { useEffect, useState } from 'react'
import { RecentRoute } from 'types'

/**
 * Hook to get recent routes from localStorage for the current user and site
 * @param siteId The site ID to get routes for
 * @returns Array of recent routes, sorted by most recent first
 */
export function useRecentRoutes(siteId?: string): RecentRoute[] {
  const [routes, setRoutes] = useState<RecentRoute[]>([])
  const { user } = useGeckoPermissions()

  useEffect(() => {
    const userId = user?.id

    if (!userId || !siteId) {
      setRoutes([])
      return
    }

    const loadRoutes = () => {
      setRoutes(RecentRouteStorage.getRecentRoutes(userId, siteId))
    }

    // Load initial routes
    loadRoutes()

    // Listen for storage changes from other tabs/windows
    const handleStorageChange = (e: StorageEvent) => {
      // Check if the storage key matches this user and site
      if (e.key?.startsWith(`gecko_recent_routes_${userId}_${siteId}`)) {
        loadRoutes()
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [user, siteId])

  return routes
}
